import { toLonLat } from "ol/proj";

/**
 * Форматирует координату с префиксом N/S/E/W и 4 знаками после запятой.
 * @param {number} coordinate - Значение координаты.
 * @param {boolean} isLon - true для долготы (E/W), false для широты (N/S).
 * @returns {string} Отформатированная координата (например "N55.7558").
 */
function getCoordinatesFormatted(coordinate, isLon) {
  const prefix = isLon ? coordinate > 0 ? 'E' : 'W' : coordinate > 0 ? 'N' : 'S';
  return `${prefix}${Math.round(coordinate * 10000) / 10000}`;
}

/**
 * Конвертирует OpenLayers [x, y] координаты в отформатированную строку "N/S E/W".
 * @param {number[]} coordinates - Массив [x, y] в проекции OpenLayers.
 * @returns {string} Строка вида "N55.7558 E37.6176".
 */
function getCoordinatesToLonLat(coordinates) {
  return toLonLat(coordinates).map((coord, i) => (
    getCoordinatesFormatted(coord, i === 0)
  )).reverse().join(' ');
}

export {
  getCoordinatesFormatted,
  getCoordinatesToLonLat,
};
